import React from "react";
import { FormattedMessage } from "react-intl";
import "./home-main.scss";

import { Text, Icon, Button } from "@ui-kit";

const HomeMain = ({ viewModalSignup }) => {
  return (
    <div className="home-main">
      <div className="main__container d-flex jc-center">
        <div className="home-main__info">
          <Text as="h2">
            <FormattedMessage
              id="home-main.info.title"
              defaultMessage="KeyHunter.net - Find the best selling keywords for Shutterstock"
            />
          </Text>
          <Text as="h4">
            <FormattedMessage
              id="home-main.info.content"
              defaultMessage="Increase your stock sales with smart keyword selection. No need for deep English - we'll do it all for you!"
            />
          </Text>
          <div className="info__actions">
            <Button onClick={viewModalSignup}>
            <FormattedMessage
              id="home-main.info.button"
              defaultMessage="Try it"
            />
            </Button>
          </div>
        </div>
        <div className="home-main__banner">
          <Icon src="/images/banner_money.png" />
        </div>
      </div>
    </div>
  );
};

export default HomeMain;
